import { Tooltip } from '@civilgrid/ui/components';
import Icon from '~/components2/Icon';

/** Icon button inside the PH# field that fills in the project's next free number. */
export function PhNumberAutoNumberButton({ suggestion, onUse }: { suggestion: string; onUse: (n: string) => void }) {
  return (
    <Tooltip asChild text="Auto-number">
      <button
        type="button"
        aria-label={`Auto-number PH# to ${suggestion}`}
        data-testid="pothole-ph-number.auto-number"
        className="flex cursor-pointer items-center rounded-sm p-1 text-primary-dark hover:bg-grey-20 focus-ring"
        onClick={() => onUse(suggestion)}
      >
        <Icon icon="lightning" size={14} />
      </button>
    </Tooltip>
  );
}
